import { ResourceQueryService } from '@lib/common-sdk';
import { BreadcrumbDataQuery } from '@lib/ui-components';

export const ProjectBreadcrumbProvider: BreadcrumbDataQuery = {
  fetchFunction(id: string): () => Promise<string> {
    return function () {
      return ResourceQueryService.findOneByField<any>('/api/resource/projectViews', 'projectId', id);
    };
  },

  mapToBreadcrumb(data: any): string {
    return data.name;
  },

  query: 'projectViews',
};
